var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconScheduleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.889,
    height: 27.457,
    viewBox: "0 0 29.889 27.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-schedule-calendar",
    transform: "translate(-1097.161 7586.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M13.257,19.444a8.646,8.646,0,1,1,8.637,8.594A8.616,8.616,0,0,1,13.257,19.444Zm1.729,0A6.917,6.917,0,1,0,21.9,12.569,6.894,6.894,0,0,0,14.986,19.444Zm-2.468,4.281H2.686A2.021,2.021,0,0,1,.661,21.712L.671,4.606A2.017,2.017,0,0,1,2.686,2.593H3.7V.581H5.722V2.593h16.2V.581h2.025V2.593h1.013a2.022,2.022,0,0,1,2.025,2.013v6.151a10.5,10.5,0,0,0-2.025-.752V6.619H2.686V21.712h9.3a10.3,10.3,0,0,0,.531,2.011v0Zm8.52-3.422V15.147h1.3v4.512l3.891,2.294-.648,1.057ZM5.522,13.71v-5h5.031v5Z",
    transform: "translate(1096.5 -7586.82)",
    fill: "#0000b5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScheduleCalendar);
export default __webpack_public_path__ + "static/media/icon-schedule-calendar.17b7152723d2190dade87624896be62d.svg";
export { ForwardRef as ReactComponent };